/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Job_Match_TitleInputs */

const en_landing_feature_job_match_title = /** @type {(inputs: Landing_Feature_Job_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smart Job Matching`)
};

const de_landing_feature_job_match_title = /** @type {(inputs: Landing_Feature_Job_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligentes Job-Matching`)
};

const fr_landing_feature_job_match_title = /** @type {(inputs: Landing_Feature_Job_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching intelligent`)
};

const es_landing_feature_job_match_title = /** @type {(inputs: Landing_Feature_Job_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching inteligente`)
};

const it_landing_feature_job_match_title = /** @type {(inputs: Landing_Feature_Job_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbinamento intelligente dei lavori`)
};

const nl_landing_feature_job_match_title = /** @type {(inputs: Landing_Feature_Job_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slim banen matchen`)
};

const pl_landing_feature_job_match_title = /** @type {(inputs: Landing_Feature_Job_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligentne dopasowywanie ofert`)
};

const fi_landing_feature_job_match_title = /** @type {(inputs: Landing_Feature_Job_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Älykäs työpaikkavastaavuus`)
};

const da_landing_feature_job_match_title = /** @type {(inputs: Landing_Feature_Job_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligent jobmatch`)
};

const sv_landing_feature_job_match_title = /** @type {(inputs: Landing_Feature_Job_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smart jobbmatchning`)
};

/**
* | output |
* | --- |
* | "Smart Job Matching" |
*
* @param {Landing_Feature_Job_Match_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_job_match_title = /** @type {((inputs?: Landing_Feature_Job_Match_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Job_Match_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_job_match_title(inputs)
	if (locale === "fr") return fr_landing_feature_job_match_title(inputs)
	if (locale === "es") return es_landing_feature_job_match_title(inputs)
	if (locale === "it") return it_landing_feature_job_match_title(inputs)
	if (locale === "nl") return nl_landing_feature_job_match_title(inputs)
	if (locale === "pl") return pl_landing_feature_job_match_title(inputs)
	if (locale === "fi") return fi_landing_feature_job_match_title(inputs)
	if (locale === "da") return da_landing_feature_job_match_title(inputs)
	if (locale === "sv") return sv_landing_feature_job_match_title(inputs)
	return en_landing_feature_job_match_title(inputs)
});